<template>
  <div class="h100-40 h-scroll">
    <ejs-grid
      ref="grid"
      height="calc(100% - 0px)"
      :dataSource="data"
      :allowReordering="true"
      :allowResizing="true"
    >
      <e-columns :columns='shipColumns' textAlign='Center' width='10%' clipMode='EllipsisWithTooltip'>
        <e-column field='name' minWidth='10' :headerText='$t("NSMF.name")' textAlign='Center' width='10%' clipMode='EllipsisWithTooltip'></e-column>
        <e-column field='sST' minWidth='10' :headerText='$t("NSMF.sst")' textAlign='Center' width='10%' clipMode='EllipsisWithTooltip' :formatter='sstFormat'></e-column>
        <e-column field='sd' minWidth='10' :headerText='$t("NSMF.sd")' textAlign='Center' width='10%' clipMode='EllipsisWithTooltip'  :formatter='sdFormat'></e-column>
        <e-column field='mcc' minWidth='10' :headerText='$t("NSMF.mcc")' textAlign='Center' width='10%' clipMode='EllipsisWithTooltip' :formatter='mccFormat'></e-column>
        <e-column field='mnc' minWidth='10' :headerText='$t("NSMF.mnc")' textAlign='Center' width='10%' clipMode='EllipsisWithTooltip' :formatter='mncFormat'></e-column>
        <e-column field='serviceProfileName' minWidth='10' :headerText='$t("NSMF.serviceProfileId")' textAlign='Center' width='10%' clipMode='EllipsisWithTooltip'></e-column>
        <e-column field='neConfig' minWidth='10' :headerText='$t("NSMF.neDeploy")' textAlign='Center' width='10%' clipMode='EllipsisWithTooltip' :formatter='neDeployFormat'></e-column>
      </e-columns>
    </ejs-grid>
    <ejs-pager
      ref="pager"
      @click="getSliceProfileListData()"
      :pageSize="page.pageSize"
      :currentPage="page.pageNo"
      :totalRecordsCount="page.totalCount"
      :pageCount="page.pageCount"
    ></ejs-pager>
    <CustomDialog
      ref="addDialog"
      :element="dialog.element.addDialogSetting"
      :styles="dialog.element.addDialogSetting.styles"
    >
      <template v-slot:dialog-content>
        <AddSliceProfile ref="addContent"></AddSliceProfile>
      </template>
    </CustomDialog>
  </div>
</template>
<script>
import {
  Reorder,
  Resize, 
} from "@syncfusion/ej2-vue-grids";
import CustomDialog from "../../common/CustomDialog";
import AddSliceProfile from "./AddSliceProfile";
import { EventBus } from "../../../plugins/eventBus";

export default {
  name: "SliceProfileTable",
  components: {
    CustomDialog,
    AddSliceProfile
  },
  data() {
    return {
      data: [],
      page: {
        pageNo: 1,
        pageSize: 10,
        totalCount: 0,
        pageCount: 10
      },
      dialog: {
        element: {
          addDialogSetting: {
            styles: {
              width: "860px",
              height: "717px",
              model: true,
              visible: false
            },
            target: "#app",
            title: this.$t("NSMF.createSliceProfile"),
            refName: "add",
            isClose: true,
            buttonGroup: [
              {
                click: this.dialogHide,
                buttonModel: { content: this.$t("Common.cancel") }
              },
              {
                click: this.saveAddTask,
                buttonModel: {
                  content: this.$t("Common.confirm"),
                  isPrimary: true
                }
              }
            ]
          }
        }
      },
      shipColumns: [
        {
          field: "ShippedDate",
          headerText: "Shipped Date",
          format: "yMd",
          textAlign: "Right",
          width: 150,
          minWidth: 10
        },
        {
          field: "ShipCountry",
          headerText: "Ship Country",
          width: 150,
          minWidth: 10
        }
      ]
    };
  },
  provide: {
    grid: [Reorder, Resize]
  },
  methods: {
    sstFormat(grids, data) {
      if (null !== data && undefined !== data && null !== data.sNSSAIList) {
        let sstSource = data.sNSSAIList.split(":")[0];
        if (sstSource === "1") {
          return "eMBB";
        } else if (sstSource === "2") {
          return "URLLC";
        } else if (sstSource === "3") {
          return "MIoT";
        } else if (sstSource === "4") {
          return "V2X";
        }
      } else {
        return "";
      }
    },

    mccFormat(grids, data) {
      return data.pLMNList.split(":")[0];
    },
    mncFormat(grids, data) {
      return data.pLMNList.split(":")[1];
    },
    sdFormat(grids, data) {
      return data.sNSSAIList.split(":")[1];
    },
    neDeployFormat(grids, data) {
      let neDeployStr='';
      const neList=JSON.parse(data.neConfig);
      neList.forEach((itemNe) => {
                neDeployStr+=itemNe.neType+';'
              });
      return neDeployStr;
    },
    dialogHide() {
      this.$refs.addDialog;
      this.$refs.addDialog.clear();
      this.$refs.addDialog.close();
    },
    getCheckedData(selectOnly) {
      // false: 不支持多选   true: 支持多选
      const selectedRecords = this.$refs.grid.getSelectedRecords();
      if (selectedRecords.length < 1) {
        EventBus.$emit("toast", {
          type: "warning",
          content: `${this.$t("Alarm.no_checked")}`
        });
        return false;
      }
      if (selectedRecords.length > 1 && !selectOnly) {
        EventBus.$emit("toast", {
          type: "warning",
          content: `${this.$t("Alarm.too_many_checked")}!`
        });
        return false;
      }
      return selectedRecords;
    },
    getSliceProfileListData() {
      // 获取表格数据
      const This = this;
      This.page.pageNo = This.$refs.pager.ej2Instances.currentPage;
      const params = {
        pageNo: parseInt(This.page.pageNo, 10),
        pageSize: parseInt(This.page.pageSize, 10)
      };
      This.$axios
        .get(
          `/lte/ems/networkSlice/listSliceProfile?pageNo=${params.pageNo}&pageSize=${params.pageSize}`
        )
        .then(response => {
          console.log("response", response);
          if (response &&response.status === 200 && response.data.errorCode === "SUCCESS") {
            const result = response.data.resultVal;
            This.page.totalCount = result.totalCount;
            This.data = result.result;
            
          } else {
            EventBus.$emit("toast", {
              type: "error",
              content: response.data.errorString
            });
          }
        });
    },
    addSliceProfilePage() {
      this.$refs.addContent.clear();
      this.$refs.addDialog.show();
      this.$refs.addContent.loadNeForm();
    },
    saveAddTask() {
      const data = this.$refs.addContent.getFormData();
      if (data !== false) {
        this.dialogHide();
        this.$axios
          .post("/lte/ems/networkSlice/createSliceProfile", data)
          .then(response => {
            if (
              response &&
              response.status === 200 &&
              response.data.errorCode === "SUCCESS"
            ) {
              EventBus.$emit("toast", {
                type: "success",
                content: this.$t("NSMF.success")
              });
              this.getSliceProfileListData();
            } else {
              EventBus.$emit("toast", {
                type: "error",
                content: response.data.errorString
              });
            }
          });
      }
    },
    deleteSliceProfilePage() {
      // 删除任务
      const checkedDataList = this.getCheckedData(false);
      if (checkedDataList) {
        const checkedData = checkedDataList[0];
        this.$layer.confirm({
          msg: this.$t("NSMF.deleteSliceProfile"),
          btn1: { msg: this.$t("Common.cancel") },
          btn2: {
            msg: this.$t("Common.confirm"),
            func: () => {
              this.$axios
                .post(`/lte/ems/networkSlice/delSliceProfile/${checkedData.id}`)
                .then(response => {
                  if (
                    response &&
                    response.status === 200 &&
                    response.data.errorCode === "SUCCESS"
                  ) {
                    EventBus.$emit("toast", {
                      type: "success",
                      content: this.$t("Common.tips.success")
                    });
                    this.getSliceProfileListData();
                  } else {
                    EventBus.$emit("toast", {
                      type: "error",
                      content: response.data.errorString
                    });
                  }
                });
            }
          }
        });
      }
    }
  },
  mounted() {
    this.getSliceProfileListData();
  }
};
</script>
